<template>
  <el-col :span="24">
    <el-form-item
      size="small"
      v-for="form in forms"
      :key="form.label"
      :prop="form.id"
      :label="form.label"
      :rules="form.rules"
    >
      <el-input
        v-if="form.type == 'text' || form.type == 'number'"
        :disabled="form.disable"
        v-model="Brand[form.id]"
        :type="form.type"
        :placeholder="`Please input ${form.label}`"
      ></el-input>
      <el-input
        v-else-if="form.type == 'textarea'"
        type="textarea"
        :disabled="form.disable"
        :rows="2"
        :placeholder="`Please input ${form.label}`"
        v-model="Brand[form.id]"
      ></el-input>
      <el-select
        v-else-if="form.type == 'select'"
        v-model="Brand[form.id]"
        style="width: 100%"
        filterable
        remote
        :remote-method="form.onSearch"
        :loading="form.onLoading"
      >
        <el-option
          v-for="item in form.data"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        ></el-option>
        <el-row v-if="form.loadMore" type="flex" justify="center">
          <el-button :loading="form.onLoading" size="mini" round @click="form.loadMore">Load More</el-button>
        </el-row>
      </el-select>
    </el-form-item>

    <el-form-item size="small" prop="picture" label="Picture">
      <el-row>
        <el-image style="width: 100%; height: 260px" :src="Brand.brandLogo" fit="contain"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputPicture"
          accept="image/*"
          @change="e => onFilePicked(e, 'picture')"
        />

        <el-row type="flex" justify="center" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('picture')"
              style="width: 100%"
            >Upload</el-button>
          </el-col>
        </el-row>
      </el-row>
    </el-form-item>
  </el-col>
</template>

<script>
import S3Client from "../../common/S3/S3Client";
import configS3 from "../../common/S3/configS3";
import { mapActions, mapState } from "vuex";
export default {
  props: ["Brand", 'from'],
  data() {
    return {
      limitPrincipal: 25,
    };
  },
  computed: {
    ...mapState({
      principals: state => state.principal.principals,
    }),
    forms() {
      return [
        {
          type: "text",
          id: "brandCode",
          label: "Brand Code",
          rules: [
            { required: true, message: "NIK is required", trigger: "blur" }
          ],
          disable: false
        },
        {
          type: "text",
          id: "brandName",
          label: "Brand Name",
          rules: [
            { required: true, message: "Brand is required", trigger: "blur" }
          ],
          disable: false
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          rules: [],
          disable: false
        },
        {
          type: "select",
          id: "principalId",
          label: "Principal ID",
          rules: [],
          data: this.principals.data.map(item => {
            item.name = `${item.principalCode} - ${item.principalName}`;
            item.value = item.id;
            return item;
          }),
          loadMore: this.loadMorePrincipal,
          onSearch: this.onSearchPrincipal,
          onLoading: this.principals.isLoading,
          disable: false
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getPrincipal: "principal/GetPrincipals",
    }),
    onSearchPrincipal(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getPrincipal(option);
    },
    loadMorePrincipal() {
      this.limitPrincipal += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitPrincipal,
        }
      };
      this.getPrincipal(option);
    },
    onPickFile() {
      this.$refs.fileInputPicture.click();
    },
    async onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      const config = configS3(
        "fastmart-image",
        `${process.env.NODE_ENV}/brand`
      );
      const file = await S3Client.uploadFile(files[0], config);
      fileReader.addEventListener("load", () => {
        this.Brand.brandLogo = file.location;
      });
      fileReader.readAsDataURL(files[0]);
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getPrincipal(option);
  }
};
</script>

<style></style>
